const fade = {
  in: {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  out: {
    initial: {
      opacity: 1
    },
    animate: {
      opacity: 0
    },
    exit: {
      opacity: 1
    }
  }
};

export { fade };
//# sourceMappingURL=fade.js.map
